import index from "./examRegistration.vue";
export default index;
